@if (tabs.length > 1) {
<ul [ngClass]="spacebetween ? 'tab-nav -spaceBetween' : 'tab-nav'" #nav>
  @for (tab of tabs; track tab) { @if (tab) {
  <li [ngClass]="spacebetween ? '-spaceBetweenFlex' : ''" [class.is-active]="tab.title === selectedLanguage">
    <button type="button" (click)="onSelect(tab.title)" [class.is-active]="tab.title === selectedLanguage">
      {{ tab.title }}
    </button>
  </li>
  } }
</ul>
}
<div [ngClass]="'tab-content ' + tabContentPadding">
  <div #content>
    <ng-content></ng-content>
  </div>
</div>
